export const normalizeEmployeeName = (name: string): string => {
  // Defensa: los servicios "Por asignar" llegan sin nombre de empleado.
  if (!name) return "";
  return name
    .toLowerCase()
    .trim()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Etiqueta de la columna fija de la agenda diaria para servicios sin estilista
// (employeeId NULL en backend). Se usa como nombre de columna Y como clave de
// agrupación de las citas "Por asignar".
export const UNASSIGNED_COLUMN_LABEL = "Por asignar";

// Un servicio está "Por asignar" cuando no tiene estilista (employeeId
// null/0/ausente o nombre vacío).
export const isUnassignedService = (service: {
  employeeId?: number | null;
  employeeName?: string | null;
}): boolean => {
  const id = service?.employeeId;
  const hasId = id != null && id !== 0;
  const hasName = !!service?.employeeName && service.employeeName.trim() !== "";
  return !hasId && !hasName;
};
